import {
  buildingCircleTurquoise,
  buildingCircleTurquoiseHover,
  buildingPinTurquoise,
  buildingPinTurquoiseHover,
  churchCircleTurquoise,
  churchCircleTurquoiseHover,
  churchPinTurquoise,
  churchPinTurquoiseHover,
  crownCircleTurquoise,
  crownCircleTurquoiseHover,
  crownPinTurquoise,
  crownPinTurquoiseHover,
  hourglassCircleHover,
  hourglassCircleTurquoise,
  hourglassPinHover,
  hourglassPinTurquoise,
  inventeringCircleBlueStyle,
  inventeringPinTurquoiseHoverStyle,
  inventeringPinTurquoiseStyle,
  penCircleHover,
  penCircleTurquoise,
  penPinHover,
  penPinTurquoise
} from 'components/map/Styles';

import { SkyddstypEnum } from 'enums';

import { Style } from 'ol/style';

const getByggnadIcon = (isPin: boolean, isHovered: boolean) => {
  return isPin
    ? isHovered
      ? buildingPinTurquoiseHover
      : buildingPinTurquoise
    : isHovered
      ? buildingCircleTurquoiseHover
      : buildingCircleTurquoise;
};

const getKyrkligIcon = (isPin: boolean, isHovered: boolean) => {
  return isPin
    ? isHovered
      ? churchPinTurquoiseHover
      : churchPinTurquoise
    : isHovered
      ? churchCircleTurquoiseHover
      : churchCircleTurquoise;
};

const getStatligIcon = (isPin: boolean, isHovered: boolean) => {
  return isPin
    ? isHovered
      ? crownPinTurquoiseHover
      : crownPinTurquoise
    : isHovered
      ? crownCircleTurquoiseHover
      : crownCircleTurquoise;
};

const publishedIconMap = new Map<SkyddstypEnum, (isPin: boolean, isHovered: boolean) => Style>()
  .set(SkyddstypEnum.ANMALNINGSPLIKT, (isPin: boolean, isHovered: boolean) => getByggnadIcon(isPin, isHovered))
  .set(SkyddstypEnum.IDENTIFIERAT_KULTURVARDE, (isPin: boolean, isHovered: boolean) => getByggnadIcon(isPin, isHovered))
  .set(SkyddstypEnum.BYGGNADSMINNE, (isPin: boolean, isHovered: boolean) => getByggnadIcon(isPin, isHovered))
  .set(SkyddstypEnum.KYRKLIGT_KULTURMINNE, (isPin: boolean, isHovered: boolean) => getKyrkligIcon(isPin, isHovered))
  .set(SkyddstypEnum.STATLIGT_BYGGNADSMINNE, (isPin: boolean, isHovered: boolean) => getStatligIcon(isPin, isHovered));

export const resolveInventeringIcon = (isActive: boolean, isHovered: boolean): Style => {
  return !isActive
    ? inventeringCircleBlueStyle
    : isHovered
      ? inventeringPinTurquoiseHoverStyle
      : inventeringPinTurquoiseStyle;
};

export const resolveUtkastRedigerbarIcon = (isPin: boolean, isHovered: boolean): Style => {
  return isPin ? (isHovered ? penPinHover : penPinTurquoise) : isHovered ? penCircleHover : penCircleTurquoise;
};

export const resolveUtkastInckickadIcon = (isPin: boolean, isHovered: boolean): Style => {
  return isPin
    ? isHovered
      ? hourglassPinHover
      : hourglassPinTurquoise
    : isHovered
      ? hourglassCircleHover
      : hourglassCircleTurquoise;
};

export const resolvePublishedIcon = (
  isPin: boolean,
  skyddstyp: SkyddstypEnum | undefined,
  isHovered: boolean
): Style => {
  const iconResolver = skyddstyp ? publishedIconMap.get(skyddstyp) : undefined;
  return iconResolver ? iconResolver(isPin, isHovered) : buildingCircleTurquoise;
};
